const disposableEmailDomains: Array<string> = [
    "123.com",
    "aol.comom",
    "b.com",
    "byom.de",
    "chfinancialservices.xyz",
    "comast.com",
    "digdig.org",
    "exdonuts.com",
    "f5.si",
    "fuck.com",
    "gamil.com",
    "gay.com",
    "gmail.com69",
    "gmail.com786",
    "gmail.comcom",
    "gmail.come",
    "gmail.comiokaygoodthanku.keepitthere.com",
    "gmail.coml",
    "gmail.comm",
    "gmail.comsh",
    "gmail.comtheatre",
    "gmial.com",
    "goatmail.uk",
    "heisei.be",
    "honeys.be",
    "hotmail.coms",
    "hotmail.con",
    "hotsoup.be",
    "ianapromotions.xyz",
    "instaddr.ch",
    "instaddr.win",
    "jourrapide.com",
    "kpay.be",
    "kpost.be",
    "lwcss.org",
    "macr2.com",
    "magim.be",
    "magim.com",
    "mail.be",
    "mail.beximtex.com",
    "mail.bg",
    "mail.com",
    "mail.com.ph",
    "mail.ru",
    "mail2greg.com",
    "mailcatch.com",
    "mailcity.com",
    "maildrop.cc",
    "mailinato.com",
    "mailinator.com",
    "me.comm",
    "merry.pink",
    "mhailinator.com",
    "mirai.re",
    "monemail.com",
    "mscdirect.com",
    "mt2015.com",
    "necrotribe.biz",
    "null.net",
    "nycmail.com",
    "opayq.com",
    "partyheld.de",
    "peterpan.com",
    "pokemail.net",
    "poopaloop.com",
    "pp.inet.fi",
    "quicksend.ch",
    "rhyta.com",
    "sakajdkjad.com",
    "sendnow.win",
    "sharklasers.com",
    "shaw.cakohlweg",
    "sika3.com",
    "snakebite.com",
    "spamgourmet.com",
    "sudomail.com",
    "teachers.org",
    "teleworm.com",
    "teleworm.us",
    "test.de",
    "thedoghousemail.com",
    "throwam.com",
    "tradesco.cf",
    "trbvm.com",
    "tyldd.com",
    "uma3.be",
    "us.af.mil",
    "usako.net",
    "vomoto.com",
    "y7mail.com",
    "ya.ru",
    "yaho.com",
    "yaho.como.cpm",
    "yahoo.com.com",
    "yahoo.con",
    "yahoo.fryyy",
    "yahoomail.com",
    "yohoo.com",
    "yopmail.com",
    "yopmail.fr",
    "yopmail.net",
    "zipmail.com.br",
    "zippymail.info"
];
export default disposableEmailDomains;